module.exports = __webpack_public_path__ + "static/media/logo.3c794117.png";